import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f3d1c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = { class: "grid-item-head" }
const _hoisted_3 = { class: "grid-item-head-index" }
const _hoisted_4 = { class: "grid-item-head-title" }
const _hoisted_5 = { class: "update-time" }
const _hoisted_6 = { class: "update-time-inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "更新時刻", -1))
const _hoisted_8 = { class: "field-name" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "unit" }

type RainPanelRow = {
  type: string
  value: string
  unit: string
  fieldName: string
}

type RainPanelUIProps = {
  no: number
  stationName: string
  updatedAt: string
  rows: RainPanelRow[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    no: null,
    stationName: null,
    updatedAt: null,
    rows: null
  },
  setup(__props: any) {

const props = __props as {
  no: number
  stationName: string
  updatedAt: string
  rows: RainPanelRow[]
}



const elementStyle = (rowSize: number) => {
  const height = 100 / rowSize

  return {
    height: `${height}%`,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(props.no), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.stationName), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", null, _toDisplayString(props.updatedAt), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([`elements-${props.rows.length} grid-item-body-top`, "grid-item-body"])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rows, (row, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          style: _normalizeStyle(elementStyle(__props.rows.length)),
          class: "gird-item-body-element"
        }, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(row.fieldName), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(row.value), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(row.unit), 1)
        ], 4))
      }), 128))
    ], 2)
  ]))
}
}

})